export default __webpack_public_path__ + "static/B0240-2e2324493779fdc279d0b2ff787f86aa.png";